import React from 'react';

// import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const PrinsipHubunganKerja = () => {

    const prinsipHubunganKerja = [
        {
            bold: "Dewan Komisaris menghargai tugas dan kewenangan Direksi ",
            normal: "dalam menjalankan pengelolaan perusahaan sesuai peraturan perundang-undangan serta Anggaran Dasar."
        },
        {
            bold: "Direksi menghormati peran dan wewenang Dewan Komisaris ",
            normal: "dalam melakukan pengawasan serta memberikan nasihat atas kebijakan pengelolaan perusahaan sebagaimana diatur dalam Anggaran Dasar."
        },
        {
            bold: "Setiap interaksi kerja antara Direksi dan Dewan Komisaris bersifat formal kelembagaan, ",
            normal: "didasarkan pada mekanisme dan korespondensi resmi yang dapat dipertanggungjawabkan."
        },
        {
            bold: "Komunikasi informal tetap dimungkinkan, ",
            normal: "namun tidak dapat dijadikan dasar dalam pengambilan keputusan atau kebijakan resmi perusahaan."
        },
        {
            bold: "Direksi berkewajiban menyediakan informasi yang relevan kepada Dewan Komisaris ",
            normal: "secara tepat waktu, terukur, dan lengkap."
        },
        {
            bold: "Direksi dan Dewan Komisaris menyepakati tata hubungan kerja ",
            normal: "antara unit kerja di bawah Direksi dan unsur pendukung Dewan Komisaris"
        },
    ];


    return (
        <section className="bg-white pt-10">
            <div className="container mx-auto pt-10">
                {/* Header Section */}
                <div className="mb-12">
                    <h2 className="text-3xl font-bold text-[#005da2] mb-6 text-center" data-aos="fade-down">Prinsip-Prinsip Hubungan Kerja Direksi dan Dewan Komisaris</h2>
                    <p className="text-lg text-gray-700 leading-relaxed text-justify" data-aos="fade-down">
                        Direksi dan Dewan Komisaris menerapkan prinsip-prinsip hubungan kerja sebagai berikut:
                    </p>

                    {/* Mapping data prinsip */}
                    <ol className="list-decimal ml-8 space-y-2 text-lg text-gray-700 leading-relaxed" data-aos="fade-down">
                        {prinsipHubunganKerja.map((item, index) => (
                            <li key={index} className="pl-2 text-justify">
                                <span className="font-bold">{item.bold}</span>
                                <span>{item.normal}</span>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    );
};

export default PrinsipHubunganKerja;
